import { render } from "./FreeTrialRequestsView.vue?vue&type=template&id=85015930&scoped=true"
import script from "./FreeTrialRequestsView.vue?vue&type=script&lang=js"
export * from "./FreeTrialRequestsView.vue?vue&type=script&lang=js"

import "./FreeTrialRequestsView.vue?vue&type=style&index=0&id=85015930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85015930"]])

export default __exports__